export const PLAYER_PROGRESS_TRACKER_LEVELS = Array.from({ length: 10 }, (_, index) => index + 1);
export const PLAYER_PROGRESS_TRACKER_BADGE_COUNT = 5;
